<template>
  <div class="detail_review_list" id="detailReviews">

    <div class="col-12 col-lg-12 ">
      <div class="row">
        <div class="col-12">
          <h3 class="mb-3 d-flex align-items-center">
            <TyIcon icon="ty-star" class="icon-color-first mx-0 pe-2" width="2rem"/>
            {{ accommodation.review_rating.toFixed(1) }}
            <span class="d-inline-block d-md-inline"><span class="px-1">·</span>

              {{ accommodation.review_count }}
              {{ $t($vysklonujSlovo('hodnotenie', accommodation.review_count, 'ia', 'i')) }}

            </span>
          </h3>
        </div>
      </div>
    </div>


    <div class="card-header review-list d-none">

      <div class="badge badge-pill badge-reviews"
           :class="{'bg-warning': accommodation.review_rating >3 && accommodation.review_rating <= 4 , 'bg-success': accommodation.review_rating > 4, 'bg-danger': accommodation.review_rating <=3 }">
        {{ Number(accommodation.review_rating).toFixed(1).replace('.', ',') }}
      </div>

      <div class="rating-number">{{ accommodation.review_rating.toFixed(1).replace('.', ',') }}</div>

      <div class="rating-count-stars">
        <div class="rating-star" v-for="ratingStar in Math.round(accommodation.review_rating)">
          <TyIcon icon="ty-star" class="" width="1.5rem"/>
        </div>
      </div>

    </div>


    <div class="col-12" v-for="review in reviews">

      <ReviewDetailItem :review="review" :activeLocale="activeLocale" :admin_view="false"/>
    </div>



  </div>
</template>

<script setup lang="ts">
import {onMounted, PropType, ref} from "vue";
import Accommodation from "~/lib/models/Accommodation";
import {formatTime} from "~/lib/functions";
import {useNuxtApp} from "#app";
import "~/assets/less/acc_detail_review_list.css";
import AccommodationReview from "../../../../../lib/models/AccommodationReview";
import {tyrionResponse} from "../../../../../composables/tyrionResponse";
import ReviewDetailItem from "./reviews/detail_item.vue";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  activeLocale: {code: String}
});
const reviews = ref([]);
const firstLoad = ref(true);
const {$tyrionApi, $vysklonujSlovo} = useNuxtApp();
const {setTyrionResponseStatus, tyrionResponseStatus} = tyrionResponse();

onMounted(() => {
  loadReviews();
})

const loadReviews = () => {
  $tyrionApi.postTyrionUrl('/api3/accommodation/reviews', {
    body: {
      accommodation: props.accommodation.id,
      page: 1,
      limit: 20
    }, cacheTime: (60 * 60 * 2)
  }).then(res => {
    if (res.status === 'success') {
      res.data.forEach(item => {
        reviews.value.push((new AccommodationReview()).fromObject(item));
      })
    } else {
      setTyrionResponseStatus('error', res.message);
    }
  }).catch(e => {
    setTyrionResponseStatus('error', (e.response && e.response.data && e.response.data.message) ? e.response.data.message : `Reviews error: ${e.message}`);
  }).finally(() => {
    firstLoad.value = false;
  })
};

</script>


